// Локализация ОТОБРАЖАЕМЫХ названий групп плана лечения.
//
// Backend отдаёт названия групп по-русски (константа TYPE_GROUP), поэтому на
// экране их нужно переводить. Логика сравнения групп по-прежнему работает с
// русскими строками (это осознанное решение) — здесь только подписи.

// Коды типов групп (backend TYPE_GROUP) -> ключи локализации namespace
// "templates", секция groupTypes.
export const GROUP_TYPE_KEYS = {
  "1": "procedure",
  "2": "diagnostic",
  "3": "therapy",
  "4": "consultation",
  "5": "peptides",
  "6": "manipulations",
  "7": "procedure_extra",
};

// Русские названия групп -> ключ локализации. Нужно там, где нет числового кода
// (платежи, список/карточка услуг). Тип 3 приходит в двух вариантах: «Бады»
// (лист назначений, платежи, история) и «Пероральные лекарственные препараты»
// (план лечения).
const GROUP_TYPE_KEYS_BY_NAME = {
  "инфузионная терапия": "procedure",
  "инфузионная терапия (доп.)": "procedure_extra",
  "чекапы": "diagnostic",
  "пероральные лекарственные препараты": "therapy",
  "бады": "therapy",
  "консультация": "consultation",
  "пептиды": "peptides",
  "процедуры": "manipulations",
};

export const normalizeGroupTypeName = (name) =>
  String(name || "")
    .trim()
    .toLowerCase();

// Поля API приходят в двух формах: "сырое" значение и обёртка {value, access}.
const unwrap = (field) =>
  field && typeof field === "object" && "value" in field ? field.value : field;

/**
 * Ключ локализации типа группы.
 * @param {{type?: any, id?: any, name?: any}} group
 *   type — числовой код (группы плана лечения),
 *   id — код у опций get_available_group,
 *   name — русское название (когда числового кода нет).
 */
export const getGroupTypeKey = (group) => {
  if (!group) return null;

  const rawType = unwrap(group.type);
  const hasType =
    rawType !== undefined && rawType !== null && String(rawType).trim() !== "";
  const rawId = unwrap(group.id);
  const code = hasType
    ? String(rawType).trim()
    : rawId !== undefined && rawId !== null
      ? String(rawId).trim()
      : "";

  if (GROUP_TYPE_KEYS[code]) return GROUP_TYPE_KEYS[code];

  const rawName = unwrap(group.name);
  return GROUP_TYPE_KEYS_BY_NAME[normalizeGroupTypeName(rawName)] || null;
};

/**
 * Локализованное название группы. Фолбэк — исходное (русское) name.
 * @param {Function} t — функция перевода из useTranslation
 * @param {{type?: any, id?: any, name?: any}} group
 */
export const getGroupTypeLabel = (t, group) => {
  const key = getGroupTypeKey(group);
  if (key) {
    const fullKey = `groupTypes.${key}`;
    const translated = t(fullKey, { ns: "templates" });
    if (translated && translated !== fullKey) return translated;
  }
  const rawName = unwrap(group?.name);
  return rawName == null ? "" : String(rawName);
};
